import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import { extendObservable } from 'mobx'
import propTypes from 'prop-types'

import { DatePickerRange } from '@components/DatePicker'
import CollapsibleFilterGroup from '@components/CollapsibleFilterGroup'
import FilterGroup from '@components/FilterGroup'
import { Dropdown } from '@components/Autocomplete'
import Logs from '@components/Logs'
import DocumentTitle from 'react-document-title'
import { SearchPanelContainer } from '@components/Search'

const logTypes = [
  '',
  'account.create',
  'account.update',
  'client.create',
  'client.signup',
  'client.updateOther',
  'clientToProjectAvailability.create',
  'consultationPaymentDetail.create',
  'contract.create',
  'contract.update',
  'email.confirm',
  'employee.create',
  'employee.updateOther',
  'employee.updateSelf',
  'epl.create',
  'expert.completeProfile',
  'expert.create',
  'expert.signup',
  'expert.updateOther',
  'expert.setComplianceSigned',
  'expert.updateSelf',
  'expertAvailabilityToEpl.create',
  'fee.create',
  'fee.update',
  'invoicingEntity.create',
  'invoicingEntity.update',
  'office.create',
  'office.update',
  'parentAccount.create',
  'parentAccount.update',
  'project.create',
  'project.update',
  'user.login',
  'user.passwordChange'
]

class LogPage extends Component {
  static propTypes = {
    logStore: propTypes.object.isRequired
  }
  constructor (props) {
    super(props)

    extendObservable(this, {
      query: {
        type: null,
        itemId: null
      }
    })
  }
  onClearSearch = () => {
    this.props.logStore.clean()
    this.props.logStore.getLogs()
    return false
  }

  render () {
    const store = this.props.logStore
    return (
      <DocumentTitle title='Logs | Atheneum Partners'>
        <div>
          <div className='expert-search'>
            <SearchPanelContainer
              thin
              searchTitle='Logs'
              onClearSearch={this.onClearSearch}
            >
              <CollapsibleFilterGroup title='Log type' open>
                <FilterGroup label='Type'>
                  <Dropdown
                    value={store.type}
                    placeholder='Select type'
                    options={logTypes}
                    itemToString={item => item || 'Any type'}
                    onChange={val => store.setVal('type', val)}
                  />
                </FilterGroup>
              </CollapsibleFilterGroup>
              <CollapsibleFilterGroup title='Log object' open>
                <FilterGroup label='Type'>
                  <Dropdown
                    value={store.objectType}
                    placeholder='Select type'
                    options={['', 'project', 'fee', 'user', 'expert']}
                    itemToString={item => item || 'Any type'}
                    onChange={val => store.setVal('objectType', val)}
                  />
                </FilterGroup>
                <FilterGroup label='Id'>
                  <input
                    className='autocomplete__input'
                    value={store.id}
                    placeholder='Log object id'
                    onChange={e => store.setVal('objectId', e.target.value)}
                  />
                </FilterGroup>
              </CollapsibleFilterGroup>
              <CollapsibleFilterGroup title='Dates' open>
                <FilterGroup label='Logs recorded between'>
                  <DatePickerRange
                    className='datepicker-range__search-panel'
                    fromDate={store.dateFrom}
                    toDate={store.dateTo}
                    onFromChange={val => {
                      if (!val) return
                      store.setVal('dateFrom', val)
                    }}
                    onToChange={val => val => {
                      if (!val) return
                      store.setVal('dateTo', val)
                    }}
                  />
                </FilterGroup>
              </CollapsibleFilterGroup>
            </SearchPanelContainer>
            <div className='project-wrapper'>
              <Logs />
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('logStore')(observer(LogPage))
